import HttpHelpers from './helpers';

const CardsApiEndpoints = {
  tokenizeCard: (data) => {
    return HttpHelpers.authenticatedAxios
      .post('card/tokenize', data)
      .then((response) => response.data);
  },
  getCards: () => {
    return HttpHelpers.authenticatedAxios
      .get('card')
      .then((response) => response.data);
  },
  deleteCard: (cardId) => {
    return HttpHelpers.authenticatedAxios
      .delete(`card/${cardId}`)
      .then((response) => response.data);
  },
  updateCard: (cardId, data) => {
    return HttpHelpers.authenticatedAxios
      .patch(`card/${cardId}`, data)
      .then((response) => response.data);
  },
};

export default CardsApiEndpoints;
